import React, { useState } from "react";
import "./prosthetic.css";

function Prostheticeye() {
  const [currentCategory, setCurrentCategory] = useState("initialProstheticData");

  const initialProstheticData = [
    // {
    //   id: 1,
    //   name: "Basic Prosthetic Eye",
    //   type: "Standard",
    //   description: "A basic ocular prosthetic for cosmetic purposes.",
    //   price: 15000,
    //   brand: "EyeTech",
    //   image: "/prosthetic1.jpg",
    // },
    // {
    //   id: 2,
    //   name: "Custom Prosthetic Eye",
    //   type: "Custom",
    //   description: "Tailored for a perfect fit and natural appearance.",
    //   price: 25000,
    //   brand: "VisionPro",
    //   image: "/prosthetic2.jpg",
    // },
    // {
    //   id: 3,
    //   name: "Scleral Shell Prosthetic",
    //   type: "Scleral",
    //   description: "Designed to cover a damaged or discolored eye.",
    //   price: 20000,
    //   brand: "OptiClear",
    //   image: "/prosthetic3.jpg",
    // },
    // {
    //   id: 4,
    //   name: "Cosmetic Prosthetic Eye",
    //   type: "Cosmetic",
    //   description: "Focused on enhancing appearance with a realistic design.",
    //   price: 18000,
    //   brand: "BeautyVision",
    //   image: "/prosthetic4.jpg",
    // },
    // {
    //   id: 5,
    //   name: "Pediatric Prosthetic Eye",
    //   type: "Pediatric",
    //   description: "Specially made for children for comfort and durability.",
    //   price: 22000,
    //   brand: "KidOptics",
    //   image: "/prosthetic5.jpg",
    // },
  ];

  const initialProsthetic = [
    "Basic Prosthetic Eye – A standard ocular prosthesis designed for cosmetic enhancement and comfort.",
    "Custom Prosthetic Eye – Individually crafted for a natural appearance and perfect fit.",
    "Scleral Shell Prosthetic – Designed to cover a damaged or discolored eye while maintaining a natural look.",
    "Cosmetic Prosthetic Eye – Focused on aesthetic enhancement with high realism and detailing.",
    "Pediatric Prosthetic Eye – Specially made for children, ensuring comfort, durability, and a natural look.",
    "High-Definition Prosthetic Eye – Advanced prosthesis with ultra-realistic iris detailing for enhanced aesthetics.",
    "Hydrophilic Prosthetic Eye – Made with moisture-retaining materials for better comfort and wearability.",
    "Multi-Layered Prosthetic Eye – Features layered pigmentation to mimic the depth and texture of a real eye.",
    "Adaptive Prosthetic Eye – Designed for individuals with sensitive eye sockets, ensuring maximum comfort.",
    "Lightweight Prosthetic Eye – Crafted using lightweight materials to reduce strain and enhance daily wear comfort."
  ];
  

  // // Load cart from localStorage on initial render
  // const [cart, setCart] = useState(JSON.parse(localStorage.getItem("cart")) || []);
  
  // const handleAddToCart = (product) => {
  //   const existingProduct = cart.find(item => item.name === product.name);
  //   if (existingProduct) {
  //     const updatedCart = cart.map(item =>
  //       item.name === product.name ? { ...item, quantity: item.quantity + 1 } : item
  //     );
  //     setCart(updatedCart);
  //     localStorage.setItem("cart", JSON.stringify(updatedCart));
  //   } else {
  //     const newCart = [...cart, { ...product, quantity: 1 }];
  //     setCart(newCart);
  //     localStorage.setItem("cart", JSON.stringify(newCart));
  //   }
    
  //   // Show alert when product is added
  //   alert(`${product.name} has been added to the cart!`);
  // };


  // const handleSort = (criteria) => {
  //   const sortedData = [...prostheticData].sort((a, b) => {
  //     if (criteria === "name") return a.name.localeCompare(b.name);
  //     if (criteria === "type") return a.type.localeCompare(b.type);
  //     if (criteria === "price") return a.price - b.price;
  //     if (criteria === "brand") return a.brand.localeCompare(b.brand);
  //     return 0;
  //   });
  //   setProstheticData(sortedData);
  // };

  return (
    <div className="prosthetic-container">
      <h1>Prosthetic Eye Options</h1>
      <p>Explore a variety of prosthetic eye solutions to meet your needs.</p>

      {/* Sorting Dropdown */}
      {/* <div className="sorting-dropdown">
        <label htmlFor="sort-select">Sort by:</label>
        <select
          id="sort-select"
          className="sort-select"
          onChange={(e) => handleSort(e.target.value)}
        >
          <option value="name">Name</option>
          <option value="type">Type</option>
          <option value="price">Price</option>
          <option value="brand">Brand</option>
        </select>
      </div> */}


   
      {currentCategory === "initialProstheticData" && (
        <div className="prosthetic-eye-description">
          <h2></h2>
          <ul>
            {initialProsthetic.map((desc, index) => (
              <li key={index}>{desc}</li>
            ))}
          </ul>
        </div>
      )}




      {/* Prosthetic Grid */}
      {/* <div className="prosthetic-grid">
        {prostheticData.map((eye, index) => (
          <div key={index} className="prosthetic-item">
            <img
              src={eye.image}
              alt={eye.name}
              className="prosthetic-image"
            />
            <h2 className="prosthetic-name">{eye.name}</h2>
            <p className="prosthetic-type">Type: {eye.type}</p>
            <p className="prosthetic-brand">Brand: {eye.brand}</p>
            <p className="prosthetic-price">Price: Rs. {eye.price.toLocaleString()}</p>
            <p className="prosthetic-description">{eye.description}</p>
            <button
              className="add-to-cart-button"
              onClick={() => handleAddToCart(eye)}
            >
              Add to Cart
            </button>
          </div>
        ))}
      </div> */}
    </div>
  );
}

export default Prostheticeye;